import { useErrorsStore } from "@/stores/errors.js";
import { ForbiddenError, UnauthorizedError, NotFoundError } from "@/routes/errors.js";
export default function (err) {
  const store = useErrorsStore();
  // Defines how errors should be handled during state actions when an HTTP request returns an error
  if (window.location.origin.match(/(localhost|staging)/)) {
    console.error(err);
  }
  store.addError(err);
  if (err instanceof NotFoundError) throw err;
  if (err instanceof ForbiddenError) throw err;
  if (err instanceof UnauthorizedError) throw err;
}
